<ul>
  <li>
    <address><img src="/images/f1.png" alt=""> Cara, 42</address>
    <q>I was struggling to understand what was happening to my body and my doctor prescribed anti-depressants, which didn’t work for me at all. Getting the right diagnosis was game-changing.</q>
  </li>
  <li>
    <address><img src="/images/f2.png" alt=""> Vicky, 51</address>
    <q>The test was incredibly easy to do and really discreet. Having a specialist talk me through the results and help me make a care plan was the icing on the cake. It’s exactly what I needed.</q>
  </li>
  <li>
    <address><img src="/images/f3.png" alt=""> Fatima, 57</address>
    <q>My peers and I have all had similar issues. It’s shocking how little some GPs know about perimenopause. The expert from MenoAge was clear, empathetic and super responsive - absolutely fantastic.</q>
  </li>
  <li>
    <address><img src="/images/f4.png" alt=""> Sue, 53</address>
    <q>I wish MenoAge had been around a few years ago - it would have saved me countless appointments! Since I got my results and started putting my care plan into action, I’ve felt better than ever. </q>
  </li>
</ul>

<style>
  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    column-count: 2;
    column-gap: 2rem;
  }

  li {
    break-inside: avoid;
    margin-bottom: 2rem;
    padding: 3rem;
    border-radius: 2rem;
    border: 1px solid rgba(0,0,0,.08);
    box-shadow: 0 .5rem 2rem rgba(0,0,0,.08);
    background: var(--bg-1);
  }

  q {
    margin-bottom: 1rem;
    display: block;
  }

  address {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    font-size: 1.125rem;
    font-style: normal;
    font-weight: bold;
  }

  img {
    width: 3rem;
    height: 3rem;
    margin-right: 1rem;
  }

  @media (max-width: 52rem) {
    ul {
      column-count: 1;
    }
  }
</style>